import styled from 'styled-components'
import { breakpoints, ModalBackground } from '@ecommerce/shared'

export const Wrapper = styled(ModalBackground)`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
`

export const Inner = styled.div`
  background-color: ${({ theme }) => theme.colors.white};
  border-radius: ${({ theme }) => theme.borderRadius};
  width: 347px;
  min-height: fit-content;
  padding: 2rem;
  position: relative;

  @media screen and (${breakpoints.tabletPortrait.min}) {
    min-width: 360px;
  }
`

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2rem;
`

export const Body = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
`

export const TitleWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
`

export const Title = styled.p`
  font-size: 16px;
  font-weight: bold;
  line-height: 20px;
  margin: 0;
`

export const Description = styled.p`
  font-size: 15px;
  font-weight: 325;
  line-height: 20px;
  letter-spacing: -0.15px;
  margin: 0;
`

export const ActionButton = styled.div`
  .button {
    width: 100%;
  }
`
